import { AppCatalogCampaignService, AppCatalogProductService } from "../resource";

const AppCatalogCampaignModule = {
    namespaced: true,
    state: {
        list: [],
        total: 0,
        loading: false,
        error: null,
        current: null
    },
    mutations: {
        SET_LIST(state, data) {
            state.list = data;
        },
        SET_TOTAL(state, total) {
            state.total = total;
        },
        SET_LOADING(state, val) {
            state.loading = val;
        },
        SET_ERROR(state, err) {
            state.error = err;
        },
        SET_CURRENT(state, item) {
            state.current = item;
        }
    },
    actions: {
        async fetchList({ commit }, params) {
            commit("SET_LOADING", true);
            commit("SET_ERROR", null);
            try {
                const res = await AppCatalogCampaignService.list(params);
                const body = res.data || {};
                commit("SET_LIST", body.data || []);
                commit("SET_TOTAL", body.total || 0);
            } catch (err) {
                commit("SET_LIST", []);
                commit("SET_ERROR", err);
            } finally {
                commit("SET_LOADING", false);
            }
        },
        async fetchOne({ commit }, id) {
            commit("SET_LOADING", true);
            commit("SET_ERROR", null);
            try {
                const res = await AppCatalogCampaignService.get(id);
                commit("SET_CURRENT", (res.data && res.data.data) ? res.data.data : null);
            } catch (err) {
                commit("SET_CURRENT", null);
                commit("SET_ERROR", err);
            } finally {
                commit("SET_LOADING", false);
            }
        },
        create(_, payload) {
            return AppCatalogCampaignService.create(payload);
        },
        update(_, { id, payload }) {
            return AppCatalogCampaignService.update(id, payload);
        },
        remove(_, id) {
            return AppCatalogCampaignService.remove(id);
        },
        // ---- แฟลชเซล page (spec §6.2). Thin wrappers that hand the body back:
        // the page keeps its products table / SKU cache in component state, like
        // Products.vue's detailById, so nothing here touches the list state above.
        async getCampaign(_, id) {
            const res = await AppCatalogCampaignService.get(id);
            return (res && res.data && res.data.data) || null;
        },
        async patch(_, { id, payload }) {
            const res = await AppCatalogCampaignService.patch(id, payload);
            return (res && res.data) || {};
        },
        async createHeader(_, payload) {
            const res = await AppCatalogCampaignService.create(payload);
            return (res && res.data) || {};
        },
        async fetchProducts(_, { id, params }) {
            const res = await AppCatalogCampaignService.products(id, params);
            return (res && res.data) || {};
        },
        async fetchProductSkus(_, { id, productId }) {
            const res = await AppCatalogCampaignService.productSkus(id, productId);
            return (res && res.data) || {};
        },
        async addProducts(_, { id, productIds }) {
            const res = await AppCatalogCampaignService.addProducts(id, productIds);
            return (res && res.data) || {};
        },
        async removeProduct(_, { id, productId }) {
            const res = await AppCatalogCampaignService.removeProduct(id, productId);
            return (res && res.data) || {};
        },
        // Add-product modal: BE-5 — the seller product list with `campaign_id`
        // so each row says whether it is already in. Not the AppCatalogProduct
        // module's fetchList: that one writes the shared product-list state.
        async pickerProducts(_, params) {
            const res = await AppCatalogProductService.list(params);
            return (res && res.data) || {};
        }
    },
    getters: {
        list: state => state.list,
        total: state => state.total,
        loading: state => state.loading,
        error: state => state.error,
        current: state => state.current
    }
};

export default AppCatalogCampaignModule;
